import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/worker',
    children: [
      { path: '', redirect: '/worker/home' },
      { path: 'home', name: 'worker-home', component: () => import('@/modules/worker/WorkerHome.vue') },
      { path: 'scan', name: 'worker-scan', component: () => import('@/modules/worker/ScanReport.vue') },
      { path: 'wages', name: 'worker-wages', component: () => import('@/modules/worker/MyWages.vue') },
      { path: 'tasks', name: 'worker-tasks', component: () => import('@/modules/worker/MyTasks.vue') }
    ]
  }
]

export default routes
